<template>
  <ValidationProvider tag="div" class="form__text-field" :rules="rules" v-slot="{ errors }">
    <label :for="inputId">{{ label }}</label>
    <input
        :class="{invalid: errors.length != 0}"
        type="text"
        name=""
        :id="inputId"
        :placeholder="placeholder"
        :value="value"
        @input="handleInput"
    />
    <slot name="afterInput"></slot>
    <span class="error" v-if="rules != null">{{ errors[0] }}</span>
  </ValidationProvider>
</template>

<script>
export default {
  props: {
    inputId: {
      type: String,
      required: true
    },
    value: String,
    label: String,
    placeholder: String,
    rules: String
  },
  methods: {
    handleInput (e) {
      this.$emit('input', e.target.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.form__text-field {
  display: inline-block;
  margin: 10px 10px 0 0;

  label {
    font-size: 1.2em;
  }

  input,
  textarea {
    resize: none;

    display: block;
    background-color: color(6);
    border: solid 1px $color-border;
    border-radius: 2px;

    font-size: 1.2em;

    padding: 10px;
    margin-top: 10px;

    width: calc(100% - 30px);

    color: $text-color;

    &::placeholder {
      color: $text-color;
    }

    &:focus {
      border-color: color(2);
      outline: none;
    }
  }
}

div.form__text-field--60-width > input {
  width: 60%;
  display: inline-block;
}
</style>
